<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import { getContext } from 'svelte';

    let { itemIdentifier, attributes = {} } = $props();

    // svelte-ignore state_referenced_locally
    const itemContext = getContext(itemIdentifier);
    const writingMode = itemContext && itemContext.getWritingMode();

    // svelte-ignore non_reactive_update
    let widthAttr, heightAttr, dataAttrs;

    setDerivedProps();

    function setDerivedProps() {
        dataAttrs = attributes.dataAttrs || {};
        widthAttr = attributes.width;
        heightAttr = attributes.height;

        if (writingMode === 'vertical-rl' && attributes.width?.endsWith('%') && !attributes.height) {
            widthAttr = attributes.height;
            heightAttr = attributes.width;
        }
    }

    let imageElement;

    let resolvedSrc = $derived(resolveImage(attributes.src));

    /**
     * Resolve image source with asset manager and preload it
     * @param {string} source
     * @returns {string}
     */
    function resolveImage(source) {
        let src = attributes.src;
        if (source && itemContext) {
            const assetManager = itemContext.getAssetManager();
            if (assetManager) {
                src = assetManager.resolve(source);
            }
            itemContext.registerLoadingElement(function imageLoading() {
                //we wait for the image to load
                //if it fails, we consider it loaded (alt will be used)
                return new Promise(resolve => {
                    let loaded = false;
                    const load = () => {
                        if (!loaded) {
                            loaded = true;
                            resolve();
                        }
                    };
                    if (imageElement) {
                        imageElement.addEventListener('load', load);
                        imageElement.addEventListener('error', load);
                        if (!loaded && imageElement.complete && imageElement.naturalWidth !== 0) {
                            load();
                        }
                    }
                });
            });
        }
        return src;
    }
</script>

<style>
    /* responsive tables can shrink %-defined images to zero if there is no min-width */
    :global(table) img {
        min-width: 3rem;
    }
</style>

<img
    bind:this={imageElement}
    id={attributes.id}
    class={attributes.class}
    data-serial={dataAttrs['data-serial']}
    src={resolvedSrc}
    alt={attributes.alt}
    width={widthAttr}
    height={heightAttr} />
